import { Link } from "react-router-dom";
const ReportTabs = (props) => {
  return (
    <ul
      className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3"
      role="tablist"
    >
      <li className="nav-item" role="presentation">
        <Link
          to={"/customerreports"}
          className={
            props.pageName === "CUSTOMERREPORT"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          CUSTOMER REPORT
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/vendorreports"}
          className={
            props.pageName === "VOUCHERREPORT"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          VENDOR REPORT
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/expensereports"}
          className={
            props.pageName === "EXPENSEREPORT"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          EXPENSE REPORT
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/salesreports"}
          className={
            props.pageName === "SALESREPORT"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          SALES REPORT
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/purchasereports"}
          className={
            props.pageName === "PURCHASESREPORT"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          PURCHASES REPORT
        </Link>
      </li>

      <li className="nav-item" role="presentation">
        <Link
          to={"/invoicereports"}
          className={
            props.pageName === "INVOICEREPORT"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          INVOICE REPORT
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/cheque"}
          className={
            props.pageName === "CHEQUE"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          CHEQUES LIST
        </Link>
      </li>
    </ul>
  );
};

export default ReportTabs;
